export const extractNameAndFileType = (
  url: string
): {
  fileName: string;
  fileType: string;
  fileNameWithExtension: string;
} => {
  // Split the URL to get the last part, which is the file name with extension
  const parts = url.split('/');
  const fileNameWithExtension = parts[parts.length - 1];
  // Split the file name to separate the name and the file extension
  const fileParts = fileNameWithExtension.split('.');
  const fileName = fileParts.slice(0, -1).join('.');
  const fileType = fileParts[fileParts.length - 1];
  return { fileName, fileType, fileNameWithExtension };
};

export const isBase64 = (base64: string) => base64.startsWith('data:');

export const getBase64Type = (base64: string): string | undefined => {
  const regex = /^([^;]+):([^;]+)/;
  const match = base64.match(regex);

  if (!match) {
    return undefined;
  }
  switch (match[2]) {
    case 'image/jpg':
      return 'jpg';
    case 'svg':
    case 'image/svg+xml':
      return 'svg';
    case '@file/msword':
      return 'doc';
    case '@file/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'docx';
    case '@file/plain':
      return 'txt';
    case 'video/mp4':
      return 'mp4';
    case 'application/pdf':
      return 'pdf';
    case 'image/png':
      return 'png';

    default:
      return undefined;
  }
};

export const getFileExtension = (data: string): string | undefined => {
  if (isBase64(data)) {
    return getBase64Type(data);
  }
  return data.slice(data.lastIndexOf('.') + 1).split('?')[0];
};
